import NftDetails from './NftDetails';
import NftDetailsContainer from './NftDetails.container';
export default NftDetailsContainer(NftDetails);
